<template>
    <div class="content c_w_1224 ereg-wrap">
        <fieldset class="form_wrap col-12 md:col-6">
            <legend> <span class="pi pi-user mr-2"></span> Налогоплательщик (кто понёс расходы)</legend>
            <div class="mt-3" id="fio_block">
                <span class="p-float-label">
                    <InputText
                        id="taxpayer_fio"
                        v-model="tax_form.TaxPayer.fio"
                        class="w-full"
                        :class="{'p-invalid': error_form.fio}"
                        ref="taxpayer_fio"
                    />
                    <label for="taxpayer_fio">Фамилия Имя Отчество*</label>
                </span>
                <small
                    class="p-error"
                    v-for="(error_fio, error_key) in error_form.fio"
                    :key="error_key"
                >
                    {{error_fio}}
                </small>
            </div>
            <div class="mt-2" id="birth_date_block">
                <div>
                    <div>
                        <label
                            style="
                                font-size: 12px;
                                margin-left: 0.75rem;
                                color: #6c757d;
                            "
                            for="taxpayer_birth_date"
                        >Дата рождения*</label>
                    </div>
                    <InputMask
                        mask="99.99.9999" slotChar="дд.мм.гггг"
                        placeholder="Дата рождения"
                        id="taxpayer_birth_date"
                        v-model="tax_form.TaxPayer.birth_date"
                        class="p-inputmask p-inputtext p-component"
                        :class="{'p-invalid': error_form.birth_date}"
                    />
                </div>
                <small
                    class="p-error"
                    v-for="(error_birth_date, error_key) in error_form.birth_date"
                    :key="error_key"
                >
                {{error_birth_date}}
                </small>
            </div>
            <div class="mt-4" id="inn_block">
                <div class="">
                    <span class="p-float-label">
                        <InputMask
                            id="taxpayer_inn"
                            v-model="tax_form.TaxPayer.inn"
                            mask="999999999999"
                            :class="{'p-invalid': error_form.inn}"
                        />
                        <label for="taxpayer_inn">ИНН*</label>
                    </span>
                </div>
                <small
                    class="p-error"
                    v-for="(error_inn, error_key) in error_form.inn"
                    :key="error_key"
                >
                {{error_inn}}
                </small>
            </div>
            <div class="mt-4" id="phone_block">
                <span class="p-float-label">
                    <InputMask
                        id="taxpayer_phone"
                        v-model="tax_form.TaxPayer.phone"
                        mask="+7(999)999-99-99"
                        :class="{'p-invalid': error_form.phone}"
                    />
                    <label for="taxpayer_phone">Телефон*</label>
                </span>
                <small
                    class="p-error"
                    v-for="(error_phone, error_key) in error_form.phone" :key="error_key"
                >{{error_phone}}</small>
            </div>
            <div class="mt-4" id="email_block">
                <div class="">
                    <span class="p-float-label">
                        <InputText
                            id="taxpayer_email"
                            v-model="tax_form.TaxPayer.email"
                            :class="{'p-invalid': error_form.email}"
                        />
                        <label for="taxpayer_email">e-mail*</label>
                    </span>
                    <small
                        class="p-error"
                        v-for="(error_email, error_key) in error_form.email"
                        :key="error_key"
                    >
                        {{error_email}}
                    </small>
                </div>
            </div>
        </fieldset>
        <fieldset
            class="form_wrap mt-4 col-12 md:col-6"
            :class="{'p-invalid': error_form.list}"
            id="list_block"
        >
        <legend> <span class="pi pi-user mr-2"></span> Данные пациента</legend>
            <div class="m-0 formgrid grid">
                <div class="col-12" v-show="!tax_form.Patient.add">
                    <div class="flex flex-column gap-3">
                        <div v-for="(patient, key) in tax_form.Patient.list" :key="key" class="flex align-items-center">
                            <label class="ml-2">
                                <input
                                    type="radio"
                                    v-model="tax_form.Patient.change"
                                    @click="() => {
                                        tax_form.Patient.change = key;
                                        changePatient();
                                    }"
                                    name="change_patient"
                                    :value="key"
                                    class="hidden"
                                />
                                {{ patient.fio }} ( {{ family_connection_list.filter((el) => {
                                    if(el.code === patient.family_connection) {
                                        return true
                                    } else {
                                        return false
                                    }
                                })[0]["name"] }} )
                                <i class="ml-2 pi pi-pencil text-yellow-500 hover" />
                            </label>
                            <i class="ml-2 pi pi-trash text-red-500 hover"
                                @click="(event)=>{
                                    tax_form.Patient.change = key;
                                    deletePatientDialog(event);
                                }"
                            />
                        </div>
                    </div>
                    <label class="mt-4 btn btn-primary b_orange" @click="buttonAddHandler">Добавить</label>
                </div>
                <div
                    class=" col-12"
                    v-show="tax_form.Patient.add"
                >
                    <label class="btn btn-primary mr-4 mb-3"
                        v-if="tax_form.TaxPayer.fio && tax_form.TaxPayer.birth_date"
                        @click="insertMyProfile"
                    >
                        <i class="pi pi-arrow-down mr-2"></i>
                        Вставить мои данные
                    </label>
                    <div class="mt-3">
                        <span class="p-float-label">
                            <InputText
                                id="patient_fio"
                                v-model="tax_form.Patient.fio"
                                class="w-full"
                                :class="{'p-invalid': double_patient}"
                            />
                            <label for="patient_fio">Фамилия Имя Отчество пациента</label>
                        </span>
                    </div>
                    <div class="mt-3">
                        <div>
                            <label
                                for="patient_birth_date"
                                style="
                                    font-size: 12px;
                                    margin-left: 0.75rem;
                                    color: rgb(108, 117, 125);
                                "
                            >Дата рождения пациента</label>
                        </div>
                        <InputMask
                            mask="99.99.9999" slotChar="дд.мм.гггг"
                            placeholder="Дата рождения"
                            class="p-inputmask p-inputtext p-component"
                            :class="{'p-invalid': double_patient}"
                            id="patient_birth_date"
                            v-model="tax_form.Patient.birth_date"
                            v-on:keyup.enter="savePatientButton"
                        />
                        <div class="mt-3">
                            <div>
                                <label
                                    for="family_connection"
                                    style="
                                        font-size: 12px;
                                        margin-left: 0.75rem;
                                        color: rgb(108, 117, 125);
                                    "
                                >Степень родства</label>
                            </div>
                            <Dropdown
                                id="family_connection"
                                v-model="tax_form.Patient.family_connection"
                                :options="family_connection_list"
                                optionLabel="name"
                                optionValue="code"
                                placeholder="Степень родства"
                                class="w-full md:w-14rem"
                            />
                        </div>
                    </div>
                    <div class="mt-3" v-if="patient_document!==null">
                            <div>
                                <label
                                    for="patient_document_list"
                                    style="
                                        font-size: 12px;
                                        margin-left: 0.75rem;
                                        color: rgb(108, 117, 125);
                                    "
                                >Документ, удостоверяющий личность</label>
                            </div>
                            <Dropdown
                                id="patient_document_list"
                                v-model="tax_form.Patient.selected_document"
                                :options="patient_document"
                                placeholder="Документ, удостоверяющий личность"
                                class="w-full md:w-14rem"
                                @change="tax_form.Patient.document_value=''"
                            />
                    </div>
                    <div class="mt-5" v-if="tax_form.Patient.selected_document !==null">                        
                        <span class="p-float-label">
                            <Textarea 
                                id="patient_document_value" 
                                v-model="tax_form.Patient.document_value" 
                                class="w-full" 
                                rows="2" 
                                cols="30" 
                                style="resize: none" 
                            />
                            <label for="patient_document_value">{{ tax_form.Patient.selected_document=='Паспорт' || tax_form.Patient.selected_document=='Свидетельство о рождении' ? 'Серия, номер, место, дата выдачи документа у' : tax_form.Patient.selected_document }} пациента</label>
                        </span>
                        <!--span class="p-float-label">
                            <InputText
                                id="patient_document_value"
                                class="w-full"
                                v-model="tax_form.Patient.document_value"
                            />
                            <label for="patient_document_value">{{ tax_form.Patient.selected_document=='Паспорт' ? 'Серия, номер, место, дата выдачи паспорта' : tax_form.Patient.selected_document }} пациента</label>
                        </span-->
                    </div>
                    <small
                        v-if="double_patient"
                        class="p-error"
                    >
                        Пациент с такими ФИО и датой рождения уже добавлен!
                    </small>
                    <div class="mt-4 relative">
                        <label class="btn btn-primary" @click="savePatientButton">
                            <span class="mr-2" :class="button_value[change_button_value].icon"></span>
                            {{ button_value[change_button_value].label }}
                        </label>
                        <label
                            class="btn btn-danger ml-3 mt-2"
                            @click="deletePatientDialog"
                            v-show="tax_form.Patient.change!=null"
                        >
                            <span class="mr-2 pi pi-trash"></span>
                            Удалить
                        </label>

                        <label
                            class="right-0 ml-2"
                            @click="cancelPatientButton"
                        >
                            Отмена
                        </label>
                    </div>
                </div>
            </div>
            <small
                class="p-error"
                v-for="(error_list, error_key) in error_form.list"
                :key="error_key"
            >
                {{error_list}}
            </small>
        </fieldset>
        <fieldset class="form_wrap mt-4 col-12 md:col-6" id="tax_period_block">
            <legend> <span class="pi pi-calendar mr-2"></span> Налоговый период</legend>
            <div>
                <MultiSelect
                    v-model="tax_form.Tax.tax_period"
                    :options="list_tax_period"
                    placeholder="Выберите налоговый период"
                    class="w-full"
                    :class="{'p-invalid': error_form.tax_period}"
                />
            </div>
            <small
                class="p-error"
                v-for="(tax_period, error_key) in error_form.tax_period"
                :key="error_key"
            >
                {{tax_period}}
            </small>
        </fieldset>
        <fieldset class="form_wrap mt-4 col-12 md:col-6" id="receiving_address_block">
            <legend> <span class="pi pi-home mr-2"></span> Удобный адрес получения справки</legend>
            <div class="card flex justify-content-center">
                <Dropdown
                    filter
                    v-model="tax_form.Tax.receiving_address"
                    :options="office_list"
                    optionLabel="value"
                    optionValue="key"
                    placeholder="Выберите адрес получения"
                    class="w-full"
                    :class="{'p-invalid': error_form.receiving_address}"
                />
            </div>
            <small
                class="p-error"
                v-for="(receiving_address, error_key) in error_form.receiving_address"
                :key="error_key"
            >
                {{receiving_address}}
            </small>
            <InlineMessage severity="warn" class="mt-1">Способ получения справки "лично" при предъявлении паспорта удостоверяющего личность</InlineMessage>
        </fieldset>
        <fieldset class="form_wrap mt-4 col-12 md:col-6" id="file_block">
            <legend> <span class="pi pi-cloud-upload mr-2"></span> Загрузить документы</legend>
            <div
                :class="{'p-invalid': error_form.file}"
            >
                <FileUpload
                    ref="fileupload"
                    name="fileupload[]"
                    accept=".bmp,.png,.gif,.jpg,.jpeg,.tif,.tiff,.heif,.heic,.webp,.pdf"
                    url=""
                    :multiple="true"
                    :maxFileSize="100000000"
                    :showUploadButton="false"
                    :invalidFileTypeMessage="'Недопустимый тип файла. Разрешённые файлы: .bmp,.png,.gif,.jpg,.jpeg,.tif,.tiff,.heif,.heic,.webp,.pdf'"
                    :invalidFileSizeMessage="'Недопустимый размер файла. Макс.размер 50мб.'"
                >
                </FileUpload>
                <InlineMessage severity="warn" class="mt-1">Разрешённые для загрузки файлы: .bmp, .png, .gif, .jpg, .jpeg, .tif, .tiff, .heif, .heic, .webp, .pdf</InlineMessage>
            </div>
            <small
                class="p-error"
                v-for="(file, error_key) in error_form.file"
                :key="error_key"
            >
                {{file}}
            </small>
        </fieldset>
       
        <div class="form_wrap my-4 col-12 md:col-6">
            <Card>
                <template #title><div class="text-orange-500 text-xl">Уважаемые пациенты, обращаем ваше внимание</div></template>
                <template #content>
                    <p class="text-orange-500 text-justify">
                        <b>Без скана или фотографии подписанного всеми сторонами заявления справка не выдается.</b>
                    </p>
                    <p class="my-4 text-orange-500 text-justify">
                        При отсутствии возможности прикрепить скан или фото подписанного заявления вы можете подать письменное заявление непосредственно в медицинскую организацию, которая оказывала Вам услуги.
                    </p>
                    <p class="my-4 text-orange-500 text-justify">
                        В случае, если вам необходимо получить справки для налогового вычета за нескольких членов семьи, нужно заполнить отдельные заявления на каждого из них.
                    </p>
                    <p class="my-4 text-orange-500 text-justify">
                        В заявлении должны быть заполнены все необходимые поля, заявление должно быть подписано всеми сторонами. Скан или фото должны быть читаемыми.
                    </p>
                    <div 
                        v-for="(agreements_val, agreements_key) in agreements"
                        :key="agreements_key"
                        class="form-group fg_w_styler"
                    >
                        <div class="checkbox">
                            <label>
                                <div
                                    class="jq-checkbox styler"
                                    :class="{'checked': agreements_val.val}"
                                >
                                    <input
                                        type="checkbox"
                                        v-model="agreements[agreements_key]['val']"
                                        :id=agreements_key
                                        :binary="true"
                                    />
                                </div>
                                {{agreements_val.text}} (<a :href="agreements_val.link" target="_blank" class="favorite-link active">{{ agreements_val.text_link }}</a>)
                            </label>
                        </div>
                    </div>
                    <div
                        v-if="tax_form.sign"
                        class="mt-4 col-12 md:col-6"
                    >
                        <label class="right-0 ml-2 btn btn-primary" @click="sendTaxForm">
                            <i class="pi pi-spin pi-spinner" v-if="loading"></i>
                            Отправить
                        </label>
                    </div>
                </template>
            </Card>
        </div>
        <OverlayPanel ref="op">
            <p>
                Вы действительно хотите удалить пациента из справки?
            </p>
            <p>
                Ф.И.О.: <b>{{ tax_form.Patient.list[tax_form.Patient.change].fio }}</b>
            </p>
            <p>
                Дата рождения: <b>{{ dFormat(tax_form.Patient.list[tax_form.Patient.change].birth_date) }}</b>
            </p>
            <div class="my-4">
                <label class="right-0 ml-2 pi pi-check btn btn-danger" @click="deletePatientHandler">
                    Да
                </label>
                <label class="right-0 ml-4 pi pi-times btn btn-primary" @click="deletePatientDialog" autofocus>
                    Нет
                </label>
            </div>
        </OverlayPanel>
        <Dialog
            v-model:visible="tax_form_answer_visible"
            modal
            header="tax_form_answer.caption"
            :style="{ width: '50rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
            <template #header>
                <div
                    class="p-dialog-title"
                    :class="tax_form_answer.text_color"
                >
                    {{ tax_form_answer.caption }}
                </div>
            </template>
            <div class="flex flex-column align-items-center w-full gap-3 p-3 mb-3">
                <i
                    :class="tax_form_answer.icon +' '+ tax_form_answer.text_color"
                    class="text-6xl"
                ></i>
                <div
                    :class="tax_form_answer.text_color"
                    style="font-size: 2rem"
                >
                    {{ tax_form_answer.text }}
                </div>
                <p
                    :class="tax_form_answer.text_color"
                    v-html="tax_form_answer.description"
                />
            </div>
        </Dialog>
        <Toast position="bottom-right" />
    </div>
</template>

<script setup>
import InputText from 'primevue/inputtext';
import InputMask from 'primevue/inputmask';

import MultiSelect from 'primevue/multiselect';
import Dropdown from 'primevue/dropdown';

import InlineMessage from 'primevue/inlinemessage';
import OverlayPanel from 'primevue/overlaypanel';
import Textarea from 'primevue/textarea';
import Dialog from 'primevue/dialog';
import Card from 'primevue/card';
import FileUpload from 'primevue/fileupload';

import { ref, onBeforeMount, onMounted, watch, toRaw } from 'vue';

import Toast from 'primevue/toast';
import { useToast } from "primevue/usetoast";

const agreements = ref({});

const toast = useToast();

const button_value = [
    {label: "Сохранить", icon:"pi pi-plus"},
    {label: "Сохранить", icon: "pi pi-save"},
];

const def_person = {
    fio: "",
    birth_date: "",
    family_connection: null,
    selected_document: null,
    document_value: null,
};

const def_document15 = [
    "Паспорт",
];

const def_document14 = [
    "Паспорт",
    "Свидетельство о рождении",
];

const def_document13 = [
    "Свидетельство о рождении",
];

//const URL = "/site/spravka-v-nalogovuu";
const URL = process.env.NODE_ENV=="development" ? "http://10.43.232.9/site/spravka-nalogovuu" : window.location.href;

const def_tax_form_answer = {
    caption: "Ошибка!",
    icon: "pi pi-info-circle",
    text: "Ваше обращение не было доставлено",
    description: "Мы не смогли обработать ваш запрос. Попробуйте чуть позже.",
    text_color: "text-orange-500"
}

const family_connection_list = ref([
    {
        name: "Нет родства!", code: null,
    },
    {
        name: "Я сам(а)", code: 0,
    },
    {
        name: "Мой супруг(а)", code: 1,
    },
    {
        name: "Мой ребёнок", code: 2,
    },
    {
        name: "Мой отец/мать", code: 3,
    }
]);

const op = ref();

const tax_form_answer_visible = ref(false);

let token = ref(document.head.querySelector('meta[name="csrf-token"]'));

const loading = ref(false);

const office_list = ref();

const change_button_value = ref(0);
const delete_dialog = ref(false);

const list_tax_period = ref();

const tax_form = ref({});

const double_patient = ref();

const error_form = ref({});

const tax_form_answer = ref(
    {
        ...def_tax_form_answer
    }
);

const patient_document = ref(null);

const fileupload = ref();

//Очистка формы
const clearTaxForm = function() {
    tax_form.value = {
        TaxPayer: {
            inn: "",
            ...def_person,
            email: "",
            phone: "",
            comment: "",
        },
        Patient: {
            change: null,
            list: [],
            add: true,
            ...def_person,
        },
        Tax: {
            receiving_address: "",
            tax_period: "",
        },
        sign: false,
    }
}

const parseDate = function (dateStr) {
  const parts = dateStr.split('.');
  const day = parts[0];
  const month = parseInt(parts[1], 10)-1; // В JavaScript месяцы начинаются с 0
  const year = parts[2];
  return new Date(year, month, day);
}

watch(agreements, (new_agreements) => {
    let signed = true;
    for ( const agreements_key in new_agreements) {
        if(toRaw(new_agreements)[agreements_key].val == false) {
            signed = false;
        }
    }
    tax_form.value.sign = signed;
}, { deep: true });

watch(tax_form, (new_tax_form) => {
    if(new_tax_form.TaxPayer.fio !=="" ) {
        delete error_form.value["fio"];
    }
    if(new_tax_form.TaxPayer.birth_date !=="" ) {
        delete error_form.value["birth_date"];
    }
    if(new_tax_form.TaxPayer.phone !=="" ) {
        delete error_form.value["phone"];
    }
    if(new_tax_form.TaxPayer.email !=null  && new_tax_form.TaxPayer.email.length>3 ) {
        delete error_form.value["email"];
    }
    if(new_tax_form.Patient.list.length>0 ) {
        delete error_form.value["list"];
    }
    if(new_tax_form.Tax.receiving_address !=="" ) {
        delete error_form.value["receiving_address"];
    }
    if(new_tax_form.Tax.tax_period !=="" ) {
        delete error_form.value["tax_period"];
    }
    if(new_tax_form.Patient.birth_date !=="") {
        // const birth_date = new Date(tax_form.value.Patient.birth_date);
        const birth_date = parseDate(tax_form.value.Patient.birth_date);
        const now_date = new Date();
        const diff_date = Math.abs(now_date-birth_date) / (1000 * 24 * 60 * 60 * 365) ;
        if(diff_date>=15) {
            patient_document.value = def_document15;
        } else if(diff_date>=14) {
            patient_document.value = def_document14;
        } else {
            patient_document.value = def_document13;
        }
    } else {
        tax_form.value.Patient.selected_document = null;
    }
    if(new_tax_form.Patient.selected_document =="" ) {
        tax_form.value.Patient.document_value = null;
        patient_document.value = null;
        tax_form.value.Patient.selected_document = null
    }

}, { deep: true });

onBeforeMount(() => {
    console.log("NODE_ENV", process.env.NODE_ENV);
    clearTaxForm();
    getOfficeList();
    getTaxPeriodList();
    getAgreement();
})

onMounted(() => {
    console.log("onMounted method");
//   if(token.value && typeof(token.value.content) !=="undefined") {
//     // console.log(token.value.content);
//   }
});

const getAgreement = function() {
    const request = {
        jsonrpc: "2.0",
        method: "get_agreement",
        id: 3,
    }
    fetch(URL, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'x-csrf-token': token.value.content,
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(request)
    })
    .then(
        (response) => {
            try {
                const data = response.json();
                data.then(
                    (list_data) => {
                        agreements.value = {...list_data.result};
                    }
                );
                console.log("agreements = ", agreements.value);
            } catch (err) {
                toast.add({
                    severity: 'error',
                    summary: 'Ошибка',
                    detail: 'Ошибка обработки данных ' + err,
                    life: 3000
                });
            }
        }
    )
    .catch(err => {
        toast.add({
            severity: 'error',
            summary: 'Ошибка',
            detail: 'Ошибка получения данных ' + err,
            life: 3000
        });
    })
}


const getOfficeList = function() {
    const request = {
        jsonrpc: "2.0",
        method: "get_office_list",
        id: 1,
    }
    fetch(URL, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'x-csrf-token': token.value.content,
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(request)
    })
    .then(
        (response) => {
            try {
                const data = response.json();
                data.then(
                    (list_data) => {
                        office_list.value = list_data.result;
                    }
                );
            } catch (err) {
                toast.add({
                    severity: 'error',
                    summary: 'Ошибка',
                    detail: 'Ошибка обработки данных ' + err,
                    life: 3000
                });
            }
        }
    )
    .catch(err => {
        toast.add({
            severity: 'error',
            summary: 'Ошибка',
            detail: 'Ошибка получения данных ' + err,
            life: 3000
        });
    })
}

const getTaxPeriodList = function() {
    const request = {
        jsonrpc: "2.0",
        method: "get_tax_period_list",
        id: 2,
    }
    fetch(URL, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'x-csrf-token': token.value.content,
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(request)
    })
    .then(
        (response) => {
            try {
                const data = response.json();
                data.then(
                    (list_data) => {
                        list_tax_period.value = list_data.result;
                    }
                );
            } catch (err) {
                toast.add({
                    severity: 'error',
                    summary: 'Ошибка',
                    detail: 'Ошибка обработки данных ' + err,
                    life: 3000
                });
            }
        }
    )
    .catch(err => {
        toast.add({
            severity: 'error',
            summary: 'Ошибка',
            detail: 'Ошибка получения данных ' + err,
            life: 3000
        });
    })
}

const insertMyProfile = function() {
    /*
    tax_form.value.Patient.fio = tax_form.value.TaxPayer.fio;
    tax_form.value.Patient.birth_date = tax_form.value.TaxPayer.birth_date;
    tax_form.value.Patient.family_connection = 0;
    */
    for (let key in def_person){
        tax_form.value.Patient[key] = tax_form.value.TaxPayer[key];
    }

    tax_form.value.Patient.family_connection = 0;
    tax_form.value.Patient.selected_document = "ИНН";
    tax_form.value.Patient.document_value = tax_form.value.TaxPayer.inn;

    savePatientButton();
}
const clearPatient = function() {
    tax_form.value.Patient =
    {
        ...tax_form.value.Patient,
        ...def_person,
        change: null,
        add: false,
    }
    delete_dialog.value=false;
    change_button_value.value = 0;
    double_patient.value = undefined;
}

const sendTaxForm = function() {
    if(loading.value) {
        return false;
    }

    loading.value = true;

    const formData  = new FormData();
    
    formData.append("tax_form", JSON.stringify(tax_form.value));
    for (let key in fileupload.value.files){
        let file = fileupload.value.files[key];
        formData.append("UploadFile[file][]", file);
    }

    console.log(formData);

    fetch(URL, {
        method: 'POST',
        headers: {
            // 'Content-Type': 'application/json',
            'x-csrf-token': token.value.content,
            'X-Requested-With': 'XMLHttpRequest',
            'X-Tax-Form': "sendTaxForm",
        },
        body: formData
        // body: JSON.stringify(tax_form.value)
    })
    .then(
        (response) => {
            loading.value = false;
            try {
                const data = response.json();
                data.then(
                    (items) => {
                        if(typeof(items.error) != "undefined") {
                            toast.add({
                                severity: 'warn',
                                summary: 'Внимание',
                                detail: 'Проверьте правильность заполнения формы',
                                life: 5000
                            });
                            console.log("items.error = ", items.error);
                            error_form.value = items.error;
                            for (const key in items.error) {
                                const element = document.getElementById(key + "_block");
                                if (element) {
                                    const header = document.querySelector(".header-new");
                                    let yOffset = 0;
                                    if(header) {
                                        yOffset = document.querySelector(".header-new").clientHeight;
                                    }
                                    
                                    const y = element.getBoundingClientRect().top + window.pageYOffset - yOffset;

                                    setTimeout(() => {
                                        window.scrollTo({
                                            top: y,
                                            behavior: 'smooth'
                                        });
                                    }, 100)
                                }
                                break;
                            }
                        } else if (typeof(items.success) != "undefined") {
                            tax_form_answer.value = {...def_tax_form_answer, ...items.success};
                            tax_form_answer_visible.value = true;

                            fileupload.value.clear();
                            fileupload.value = [];

                            clearTaxForm();
                            getAgreement();
                            
                        } else {
                            tax_form_answer.value = {...def_tax_form_answer};
                            tax_form_answer_visible.value = true;
                        }
                    }
                );
            } catch {
                toast.add({
                    severity: 'error',
                    summary: 'Ошибка',
                    detail: 'Ошибка загрузки данных',
                    life: 3000
                });
            }
        }
    )
    .catch(err => {
            loading.value = false;
            console.log("Ошибка сети");
            console.error(err);
            toast.add({
                severity: 'error',
                summary: 'Ошибка',
                detail: 'Ошибка загрузки данных',
                life: 3000
            });
        }
    );

}

const dFormat = function(f_date) {
    return (new Date(f_date)).toLocaleDateString();
};

const buttonAddHandler = function() {
    clearPatient();
    tax_form.value.Patient.add = true;
}

const cancelPatientButton = function() {
    clearPatient();
}

const deletePatientDialog = function(event) {
    op.value.toggle(event);
}

const deletePatientHandler = function() {
    op.value.hide();
    tax_form.value.Patient.list.splice(tax_form.value.Patient.change, 1);
    clearPatient();
}

const savePatientButton = function() {
    let family_connection = tax_form.value.Patient.family_connection !== null;
    double_patient.value = tax_form.value.Patient.list.find( (patient, idx) => {
        if(
            idx == tax_form.value.Patient.change &&
            patient.fio.toUpperCase() == tax_form.value.Patient.fio.toUpperCase() &&
            patient.birth_date == tax_form.value.Patient.birth_date
        ) {
            return false;
        }
        return patient.fio.toUpperCase() == tax_form.value.Patient.fio.toUpperCase() &&
        patient.birth_date == tax_form.value.Patient.birth_date
    } );
    if(
        change_button_value.value==0 &&
        tax_form.value.Patient.fio &&
        tax_form.value.Patient.birth_date &&
        double_patient.value == undefined &&
        family_connection
    ) {
        /*
        tax_form.value.Patient.list.push({
            "fio": tax_form.value.Patient.fio,
            "birth_date": tax_form.value.Patient.birth_date,
            "family_connection": tax_form.value.Patient.family_connection,
        });
        */
       
        let obj = {};
        for (let key in def_person){
            obj[key] = tax_form.value.Patient[key];
        }
        tax_form.value.Patient.list.push(obj);

        clearPatient();
    } else if(
        change_button_value.value==1 &&
        tax_form.value.Patient.fio &&
        tax_form.value.Patient.birth_date &&
        double_patient.value == undefined &&
        family_connection
    ) {
        let obj = {};
        for (let key in def_person){
            obj[key] = tax_form.value.Patient[key];
        }
        tax_form.value.Patient.list[tax_form.value.Patient.change] = obj;
        /*
        tax_form.value.Patient.list[tax_form.value.Patient.change] = {
            "fio": tax_form.value.Patient.fio,
            "birth_date": tax_form.value.Patient.birth_date,
            "family_connection": tax_form.value.Patient.family_connection,
        }
        */
        clearPatient();
        change_button_value.value = 0;
    }
}


const changePatient = function() {
    change_button_value.value = 1;
    for (var key in def_person){
        tax_form.value.Patient[key] = tax_form.value.Patient.list[tax_form.value.Patient.change][key];
    }
    /*
    tax_form.value.Patient.fio = tax_form.value.Patient.list[tax_form.value.Patient.change].fio;
    tax_form.value.Patient.birth_date = tax_form.value.Patient.list[tax_form.value.Patient.change].birth_date;
    
    tax_form.value.Patient.family_connection = tax_form.value.Patient.list[tax_form.value.Patient.change].family_connection;

    tax_form.value.Patient.selected_document = tax_form.value.Patient.list[tax_form.value.Patient.change].selected_document;
    */
    
    tax_form.value.Patient.add = true;
    

}

</script>
<style scoped>
    .hover {
        padding: 5px;
    }
    .hover:hover {
        border: 1px solid;
        padding: 4px;
        border-radius: 4px;
    }
    .p-inputtext.p-invalid.p-component {
        border-color: #e24c4c;
    }

</style>
